import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisplayInboundEmailComponent } from './display-inbound-email.component';

const routes: Routes = [
  {
    path: '',
    component: DisplayInboundEmailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisplayInboundEmailRoutingModule {}
